<template>

<div class="row mb-30 project-header">
    
    <div class="col-12">
        <h2 class="sub-title pb-0 mb-0 text-center text-lg-left text-xl-left">
            {{ title }} /
        </h2>
        <h1 class="project-title text-center text-lg-left">{{ $parent.model.name }}</h1>
    </div>

    <div class="col-lg-12 d-sm-flex align-items-center justify-content-between">
        <ul class="nav file-menu mt-3">
            <li @click='$parent.setPage("messages")'
                :class='["nav-item", { active : $parent.page == "messages"}]'>
                Въпроси & отговори 
                <span class="badge badge-secondary badge-lg">{{ $parent.messages }}</span>
            </li>

            <li @click='$parent.setPage("files")' 
                :class='["nav-item", { active : $parent.page == "files"}]'>
                Всички файлове
                <span class="badge badge-secondary badge-lg">{{ $parent.files }}</span>
            </li>


        </ul>

        
    </div>

</div>

</template>


<script>
    export default {
        mounted() {
            
            bus.$on('set-title', (t) => {
                this.title = t;
            })

        },

        created() {

        },

        data() {
            return {
                title : 'Въпроси & отговори'
            }
        },

        methods : {

        },

        components : {
            
        }
    }
</script>